import {Component} from '@angular/core';
import {Store} from "@ngrx/store";
import {ActivatedRoute} from "@angular/router";
import {SharedConfigService} from '../../services/shared-config.service';
import {DocScanWebComponentResult} from '../../models/document-scanning.models';
import {scanDocumentUsingWebService} from '../../+state/shared.actions';

@Component({
  selector: 'mobile-document-scanning',
  template: `
    <document-scanning
      [license]="regulaLicense"
      (docScanWebComponentSuccess)="onDocScanWebComponentSuccess($event)"
    >
    </document-scanning>
  `,
  styles: [],
})
export class MobileDocumentScanningComponent {

  regulaLicense: string;
  private formCode: string;
  private uid: string;
  private isBackoffice: boolean;

  constructor(
    private configService: SharedConfigService,
    private store: Store,
    private route: ActivatedRoute
  ) {

    this.route.queryParams.subscribe(params => {
      if (params['formCode']) {
        this.formCode = params['formCode'];
      }
      if (params['uid']) {
        this.uid = params['uid'];
        sessionStorage.setItem('uid', this.uid);
      }
      if (params['isBackoffice']) {
        this.isBackoffice = params['isBackoffice'];
      }
    });

    this.configService.getConfig().then((config) => {
      this.regulaLicense = config.regulaLicense;
    });

  }

  onDocScanWebComponentSuccess(docScanWebComponentResult: DocScanWebComponentResult) {
    this.store.dispatch(scanDocumentUsingWebService({
      formTemplateCode: this.formCode,
      docScanWebComponentResult: docScanWebComponentResult,
      isBackoffice: this.isBackoffice
    }));
  }
}
